<template>
  <div v-if="isCompositeMetricsEnabled" class="divide mt-30">
    <div data-testId="composite-title" class="composite-title mt-10" :style="{ color: color }">
      {{ questionData.composite_question[lang] }}
    </div>
    <CompositMetricTree
      :itemsTree="itemsTree"
      :lang="lang"
      :color="color"
      :onSelectAnswer="onSelectAnswer"
      :answer="answer"
      :parentType="questionData.type"
    />
  </div>
</template>
<script>
import CompositMetricTree from "./CompositeMetricTree";
export default {
  components: { CompositMetricTree },
  props: {
    questionData: Object,
    lang: {
      type: String,
      default: "pt_BR"
    },
    color: {
      type: String
    },
    onSelectAnswer: {
      type: Function,
      default: () => {}
    },
    answer: [Number, Array]
  },
  data() {
    return {
      enabledCompositeMetricsItems: {},
      itemsTree: [],
      defaultCompositeMetrics: ["detractor_enabled", "neutral_enabled", "promoter_enabled"]
    };
  },
  computed: {
    answerMetric() {
      if (!this.isValidAnswer()) {
        return "no_metric";
      }
      if (this.answer <= 6) {
        return "detractor_enabled";
      }
      if (this.answer >= 7 && this.answer <= 8) {
        return "neutral_enabled";
      }
      return "promoter_enabled";
    },
    isCompositeMetricsEnabled() {
      if (!this.hasInitialData()) {
        return false;
      }
      if (!this.itemsTree.length) {
        return false;
      }
      return true;
    }
  },
  methods: {
    isValidAnswer() {
      return typeof this.answer === "number";
    },
    hasInitialData() {
      if (!this.questionData) {
        return false;
      }
      if (!this.questionData.items) {
        return false;
      }
      if (!this.questionData.items.length) {
        return false;
      }
      if (!this.isValidAnswer()) {
        return false;
      }
      return true;
    },
    getItemsTree() {
      if (!this.questionData.items) {
        return [];
      }
      return this.questionData.items
        .map((item) => ({ ...item, items: this.getItemsChildren(item.items) }))
        .filter((item) => {
          return Boolean(item[this.answerMetric] || this.hasItems(item));
        });
    },
    getItemsChildren(children) {
      if (!children) {
        return [];
      }
      return children.filter((item) => {
        return Boolean(item[this.answerMetric]);
      });
    },
    hasItems(item) {
      return item.items && item.items.length;
    }
  },
  watch: {
    answer() {
      this.itemsTree = this.getItemsTree();
    }
  }
};
</script>
<style scoped>
.divide {
  border-top: 0.5px solid #e8e8e8;
}
.composite-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #354052;
}
</style>
